import React from "react";
import { Link } from "react-router-dom";
const ItemsMenu = ({ token, username, isActive, onToggle }) => {
  if (username.bedrijf && username.bedrijf.modules.includes("cms")) {
    if (token.role === "admin" || token.role === "manager" || token.role === "medewerker") {
      return (
        <div className="menu-item">
          <div className="menu-link" onClick={onToggle}>
            <span className="menu-icon"><i className="fa fa-window-restore"></i></span>
            <span className="menu-text">CMS</span>
            <span className={`menu-arrow ${isActive ? "rotate" : ""}`}><i className="fas fa-chevron-right"></i></span>
          </div>
          <div className={`menu-sub ${isActive ? "show" : ""}`}>
            <div className="menu-item">
              <Link to="/cms/content" className="menu-link">
                <span className="menu-icon"><i className="fa fa-book"></i></span>
                <span className="menu-text">Content manager</span>
              </Link>
            </div>
            <div className="menu-item">
              <Link to="/cms/berichten" className="menu-link">
                <span className="menu-icon"><i className="fa fa-book"></i></span>
                <span className="menu-text">Berichten</span>
              </Link>
            </div>
            <div className="menu-item">
              <Link to="/cms/types" className="menu-link">
                <span className="menu-icon"><i className="fa fa-book"></i></span>
                <span className="menu-text">Content Type Builder</span>
              </Link>
            </div>
            <div className="menu-item">
              <Link to="/cms/media" className="menu-link">
                <span className="menu-icon"><i className="fa fa-book"></i></span>
                <span className="menu-text">Media bestanden</span>
              </Link>
            </div>
            <div className="menu-item">
              <Link to="/cms/settings" className="menu-link">
                <span className="menu-icon"><i className="fa fa-cogs"></i></span>
                <span className="menu-text">Settings</span>
              </Link>
            </div>
          </div>
        </div>
      );
    } else {
      return null;
    }
  } else {
    return null;
  }
};
export default ItemsMenu;
